import { render, staticRenderFns } from "./ExportedPastelInvoicesReadOnly.vue?vue&type=template&id=474ea928"
import script from "./ExportedPastelInvoicesReadOnly.vue?vue&type=script&lang=js"
export * from "./ExportedPastelInvoicesReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports